import { Company } from '@/api/CompanyApi';
import { BaseEntity, Province } from './types';

export enum UserStatus {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
}

export enum UserType {
	ADMIN = 'admin',
	CLIENT = 'client',
	MERCHANT = 'merchant',
}

interface BaseUser extends BaseEntity {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	status: UserStatus;
	phoneNumber: string;
	userType: UserType;
	provinces: Province[];
	company: Company;
	canAddClients: boolean;
}

export interface Client extends BaseUser {
	userType: UserType.CLIENT;
	discount: number;
}

export interface Merchant extends BaseUser {
	userType: UserType.MERCHANT;
}

export type AppUser = Client | Merchant;
